<template>
    <div class="surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h3>Payment Details</h3>

                    <div v-if="loading" class="field">
                        <label>Loading payment details…</label>
                    </div>

                    <div v-else-if="error" class="field">
                        <label class="text-red-500">Error: {{ error }}</label>
                    </div>

                    <div v-else>
                        <div class="field">
                            <label>Description</label>
                            <InputText :disabled="true" :value="payfastFields.itemName"/>
                        </div>

                        <div class="field">
                            <label>Amount</label>
                            <InputText :disabled="true" :value="payfastFields.amount"/>
                        </div>

                        <div class="field">
                            <Button
                                label="Pay with PayFast"
                                class="mr-2 mb-2"
                                :disabled="!readyToPay"
                                @click="submitPayfast"/>
                        </div>

                        <form
                            v-if="readyToPay"
                            ref="payfastForm"
                            :action="payfastEndpoint"
                            method="post"
                            enctype="application/x-www-form-urlencoded"
                            class="hidden">

                            <input type="hidden" name="merchant_id" :value="payfastFields.merchantId"/>
                            <input type="hidden" name="merchant_key" :value="payfastFields.merchantKey"/>
                            <input type="hidden" name="return_url" :value="payfastFields.returnUrl"/>
                            <input type="hidden" name="cancel_url" :value="payfastFields.cancelUrl"/>
                            <input type="hidden" name="notify_url" :value="payfastFields.notifyUrl"/>
                            <input type="hidden" name="m_payment_id" :value="payfastFields.mPaymentId"/>
                            <input type="hidden" name="amount" :value="payfastFields.amount"/>
                            <input type="hidden" name="item_name" :value="payfastFields.itemName"/>
                            <input type="hidden" name="custom_str1" :value="payfastFields.customStr1"/>
                            <input type="hidden" name="custom_str2" :value="payfastFields.customStr2"/>
                            <input type="hidden" name="custom_str3" :value="payfastFields.customStr3"/>
                            <input type="hidden" name="signature" :value="payfastFields.signature"/>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PayfastPaymentsService from "@/service/PayfastPaymentsService";

export default {
    name: 'ZarPaymentButton',
    props: {
        companyReference: {type: [String, Number], required: false, default: null},
        invoiceReference: {type: [String, Number], required: false, default: null},
        signatureReference: {type: [String, Number], required: false, default: null},
    },
    data() {
        return {
            loading: true,
            error: '',
            readyToPay: false,

            // payfastEndpoint: 'https://sandbox.payfast.co.za/eng/process',
            payfastEndpoint: 'https://www.payfast.co.za/eng/process',

            payfastFields: {
                merchantId: '',
                merchantKey: '',
                returnUrl: '',
                cancelUrl: '',
                notifyUrl: '',
                mPaymentId: '',
                amount: '',
                itemName: '',
                customStr1: '',
                customStr2: '',
                customStr3: '',
                signature: '',
            },
        };
    },
    async mounted() {
        try {
            console.debug('[ZarPaymentButton][mounted] Getting payment details for : ',
                this.companyReference, this.invoiceReference, this.signatureReference);

            const res = await PayfastPaymentsService.getPaymentDetails(
                this.companyReference,
                this.invoiceReference,
                this.signatureReference
            );

            if (res.data.error) {
                this.error = res.data.error;
                console.log('[ZarPaymentButton][mounted] this.error = ', this.error);
                this.readyToPay = false;
            } else {
                this.payfastFields = {
                    merchantId: res.data.merchantId,
                    merchantKey: res.data.merchantKey,
                    returnUrl: res.data.returnUrl,
                    cancelUrl: res.data.cancelUrl,
                    notifyUrl: res.data.notifyUrl,
                    mPaymentId: res.data.mPaymentId,
                    amount: res.data.amount,
                    itemName: res.data.itemName,
                    customStr1: res.data.customStr1,
                    customStr2: res.data.customStr2,
                    customStr3: res.data.customStr3,
                    signature: res.data.signature,
                };

                console.log('[ZarPaymentButton][mounted] this.payfastFields = ', this.payfastFields);

                this.readyToPay = true;
            }
        } catch (e) {
            console.error('[ZarPaymentButton][mounted] Error:', e);
            this.error = e?.message || 'Failed to load PayFast payment details.';
        } finally {
            this.loading = false;
        }
    },
    methods: {
        submitPayfast() {
            console.log('[ZarPaymentButton][submitPayfast] readyToPay =', this.readyToPay);
            console.log('[ZarPaymentButton][submitPayfast] payfastForm ref =', this.$refs.payfastForm);

            if (!this.readyToPay) return;
            if (!this.$refs.payfastForm) {
                console.error('Form not found in DOM at submit time.');
                return;
            }

            this.$refs.payfastForm.submit();
        },
    },
};
</script>
